import { useState, useRef } from "react";
import { Button, Box, Modal } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import licence from "../../assets/images/license.svg";
import closeIcon from "../../assets/images/closeicon.svg";
import checkImg from "../../assets/images/check_circle.svg";

import AccessibleTooltip from "../Tooltip/Tooltip.js";
import "./mustyle.scss";

import {
  useAutoFocus,
  useHandleClose,
  useHandleSave,
  handleModalCloseEvent,
} from "../../utils/licenceModalUtils.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
};

const LicenceModal = ({ openModal, setOpenModal, heading, licenseData }) => {
  const dispatch = useDispatch();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { sendLicenceSuccess } = useSelector((state) => state.buildingData);
  const firstInputRef = useRef(null);

  useAutoFocus(openModal, firstInputRef);
  const handleClose = useHandleClose(dispatch, setOpenModal, sendLicenceSuccess);
  const handleSave = useHandleSave(dispatch, licenseData);

  return (
    <div className="delte_modal_wrapper">
      <Modal
        open={openModal}
        aria-labelledby="license-modal-heading"
        aria-modal="true"
        onClose={(event, reason) =>
          handleModalCloseEvent(event, reason, tooltipOpen, setTooltipOpen, handleClose)
        }
        className="globalForm"
      >
        <div role="none">
          <Box
            role="dialog"
            aria-modal="true"
            sx={style}
            aria-labelledby="license-modal-heading"
            className="mainModalBox"
          >
            {/* Modal Header */}
            <div className="Modal_header" style={{ justifyContent: "space-between" }}>
              <h1 id="license-modal-heading">
                <img src={licence} alt="" aria-hidden style={{ marginRight: "16px" }} />
                {heading}
              </h1>

              <AccessibleTooltip
                title="Close"
                open={tooltipOpen}
                customclass="modalcloseTooltip"
              >
                <button
                  ref={firstInputRef}
                  onClick={handleClose}
                  className="close_button_modal"
                  aria-label="Close"
                  data-testid="close-btn"
                  onFocus={() => setTooltipOpen(true)}
                  onBlur={() => setTooltipOpen(false)}
                  onMouseEnter={() => setTooltipOpen(true)}
                  onMouseLeave={() => setTooltipOpen(false)}
                >
                  <img src={closeIcon} alt="" aria-hidden="true" />
                </button>
              </AccessibleTooltip>
            </div>

            {/* Modal Content */}
            {!sendLicenceSuccess ? (
              <>
                <div className="Modal_middle">
                  <div className="inputdrapper">
                    <p>Send License to customer via email.</p>
                  </div>
                </div>

                <div className="Modal_footer">
                  <Box sx={{ display: "flex" }}>
                    <Button
                      variant="outlined"
                      className="cancelBtn"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginLeft: "10px" }}
                      variant="contained"
                      className="saveBtn"
                      onClick={handleSave}
                    >
                      Send
                    </Button>
                  </Box>
                </div>
              </>
            ) : (
              <div className="emailsent-wrapper manageUser_details">
                <img src={checkImg} alt="success" />
                <h2>Success</h2>
                <p>Email sent successfully to customer with License</p>
                <div className="Modal_footer" style={{ marginBottom: "15px" }}></div>
              </div>
            )}
          </Box>
        </div>
      </Modal>
    </div>
  );
};

LicenceModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  licenseData: PropTypes.object.isRequired,
};

export default LicenceModal;
